// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EMS7","colMin":"styles_colMin__KCPef"};